/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Emptycourses1Inputs */

const zh_course_emptycourses1 = /** @type {(inputs: Course_Emptycourses1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你还没有创建任何课程`)
};

const en_course_emptycourses1 = /** @type {(inputs: Course_Emptycourses1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You haven't created any courses yet`)
};

const es_course_emptycourses1 = /** @type {(inputs: Course_Emptycourses1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no has creado ningún curso`)
};

/**
* | output |
* | --- |
* | "You haven't created any courses yet" |
*
* @param {Course_Emptycourses1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_emptycourses1 = /** @type {((inputs?: Course_Emptycourses1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Emptycourses1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_emptycourses1(inputs)
	if (locale === "en") return en_course_emptycourses1(inputs)
	return es_course_emptycourses1(inputs)
});
export { course_emptycourses1 as "course_emptyCourses" }